import { useState, useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";

const AppliedFilters = ({ chips = [] }) => {
  const [openGroup, setOpenGroup] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpenGroup(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (chips.length === 0) return null;

  const groups = chips.reduce((acc, chip) => {
    if (!acc[chip.label]) acc[chip.label] = [];
    acc[chip.label].push(chip.value);
    return acc;
  }, {});

  return (
    <div ref={containerRef} className="flex flex-wrap items-center mt-[5px] gap-[6px] mb-[10px]">
      {Object.entries(groups).map(([label, values]) => {
        const isOpen = openGroup === label;
        return (
          <div key={label} className="relative">
            <button
              onClick={() => setOpenGroup(isOpen ? null : label)}
              className={`inline-flex items-center gap-[4px] px-[8px] py-[3px] rounded-full text-[11px] font-medium bg-white text-gray-900 border border-gray-300 cursor-pointer whitespace-nowrap transition-shadow duration-150 ${isOpen ? "ring-2 ring-[#c7d2fe]" : ""}`}
            >
              {label}
              <span className="bg-[#bb1ccc] text-white text-[10px] font-semibold rounded-full px-[5px] leading-[1.5]">
                {values.length}
              </span>
              <ChevronDown
                size={11}
                className={`text-gray-500 transition-transform duration-200 ${isOpen ? "rotate-180" : "rotate-0"}`}
              />
            </button>

            {isOpen && (
              <div className="absolute top-[calc(100%+4px)] left-0 z-[9999] bg-white border border-gray-200 rounded-[8px] shadow-[0_4px_16px_rgba(0,0,0,0.10)] min-w-[160px] py-[3px]">
                {values.map((v, i) => (
                  <div
                    key={i}
                    className={`px-[12px] py-[5px] text-[11px] text-gray-700 ${i < values.length - 1 ? "border-b border-gray-100" : ""}`}
                  >
                    {v}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AppliedFilters;
